import { Component, OnInit } from '@angular/core';
import { HowToTicketsService } from 'src/app/core/services/how-to-tickets/how-to-tickets.service';
import { DatePipe } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PurchaseFlowComponent } from 'src/app/shared/cinejoy/common/purchase-flow/purchase-flow.component';

@Component({
  selector: 'app-how-to-tickets',
  templateUrl: './how-to-tickets.component.html',
  styleUrls: ['./how-to-tickets.component.css'],
  providers: [DatePipe]
})
export class HowToTicketsComponent implements OnInit {

  ticketInfo: any;
  timezone:any
  dateRange: string;
  range: string
  endDateRange: any

  constructor(public service: HowToTicketsService,private datePipe: DatePipe,
    private modalService: NgbModal) { }

  ngOnInit(): void {
    this.service.getHowToTicketsInfo().subscribe(data => {
      this.ticketInfo = data;
      
      const formattedStartDate = this.datePipe.transform(this.ticketInfo.showcaseMovies.startDate, 'MMMM d');
      const formattedEndDate = this.datePipe.transform(this.ticketInfo.showcaseMovies.endDate, 'd, yyyy');
      const formatEndDate = this.datePipe.transform(this.ticketInfo.showcaseMovies.endDate, 'd');

      this.range = `${formattedStartDate}-${formatEndDate}`;

      this.dateRange = `${formattedStartDate}-${formattedEndDate}`;

      const timestampSeconds = this.ticketInfo.showcaseMovies.endDate / 1000;
      const originalDate = new Date(timestampSeconds * 1000);

      const newDate = new Date(originalDate.getTime() + 2 * 24 * 60 * 60 * 1000);
      this.endDateRange = this.datePipe.transform(newDate, 'MMMM d');

    });
  }

  open(premiere: any, purchaseStage: string): void {
    const modalRef = this.modalService.open(PurchaseFlowComponent, {
      size: 'lg',
      backdrop: 'static',
    })
    modalRef.componentInstance.premiere = premiere;
    modalRef.componentInstance.purchaseStage = purchaseStage;
    modalRef.result.then(
			(result) => {

			},
			(reason) => {

			},
		);
  }
}
